export const setAuthHeaders = (headers: Headers) => {
    Object.entries<string>(JSON.parse(window.localStorage.getItem('auth_headers') || '{}')).forEach(([key, value]) => {
        headers.set(key, value);
    });

    return headers;
};
